import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { ProtectedRouteContext } from '../../../Context';

import './Dropdown.scss';

export default function Dropdown(props) {
    /**
     * @type {ShipyardQuestion}
     */
    const question = props.question;
    const shouldShowErrors = props.shouldShowErrors;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated; // callback func owned by Application
    const previouslyChosen = question.chosenOptions && question.chosenOptions.length > 0 ? question.chosenOptions[0] : undefined;

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [chosenValue, setChosenValue] = useState(previouslyChosen);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    const handleChange = async (event) => {
        const newChosenId = parseInt(event.target.value);
        setSaving(true);
        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseIds: [newChosenId] },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            return;
        }

        question.chosenOptions = [newChosenId];
        setChosenValue(newChosenId);
        var validity = question.validator(question);
        question.isValid = validity.isValid;
        question.invalidReason = validity.invalidReason;
        answerUpdated();
        setSaving(false);
    };

    return (
        <div
            className={classNames({
                'question-wrapper': true,
                dropdown: true,
                invalid: !question.isValid && shouldShowErrors,
                disabled: disabled,
            })}
        >
            <label htmlFor={'quest-' + question.id}>
                <span className={classNames({ required: question.minResponseRequired > 0 })}>{question.text[lang]}</span>
                {saving ? <FontAwesomeIcon icon={faSpinner} /> : null}
            </label>
            <select
                id={'quest-' + question.id}
                aria-describedby={'quest-err-' + question.id}
                disabled={saving}
                value={chosenValue}
                onChange={handleChange}
            >
                <option
                    hidden
                    value={''}
                ></option>
                {question.options.map((option) => {
                    return (
                        <option
                            key={`quest-${question.id}-opt-${option.id}`}
                            value={option.id}
                            disabled={option?.isDisplayOnly === 1}
                        >
                            {option.text[lang]}
                        </option>
                    );
                })}
            </select>

            <span
                className="invalid-reason"
                id={'quest-err-' + question.id}
            >
                {typeof question.invalidReason === 'string'
                    ? t(question.invalidReason)
                    : question.invalidReason[userSettings.LanguagePreference]}
            </span>
        </div>
    );
}
